import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import '../Common/styles/Charts.css';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { menus } from './Common/Consts/sidebar';
import { HomeNav } from '../Common/Home/HomeNav';
import CensusFiltersProvider from './Common/Filters/contexts/CensusFiltersContext';
import Overview from './Overview/Overview';
import Households from './Households/Households';
import People from './People/People';
import Pct from './Pct/Pct';

function DashBoardCensus() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <CensusFiltersProvider>
                <ReactQueryDevtools initialIsOpen={false} />
                <div className="dashboards-page">
                    <HomeNav menus={menus} />
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="overview" replace />}
                        />

                        <Route path="/overview/*" element={<Overview />} />
                        <Route path="/households/*" element={<Households />} />
                        <Route path="/people/*" element={<People />} />
                        <Route path="/pct/*" element={<Pct />} />
                    </Routes>
                </div>
            </CensusFiltersProvider>
        </QueryClientProvider>
    );
}

export default DashBoardCensus;
